export default __webpack_public_path__ + "static/media/mind-matters.f881f9f3.png";